export default __webpack_public_path__ + "static/media/user.fd03c13f.svg";